//인증번호 발송 완료
export const otp_request_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'complete_sms' })
}

//가입 완료
export const complete_signup_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'complete_signup' })
}

//로그인
export const login_complete_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'login' })
}

//탈퇴 30일이전 재가입시도
export const d30_resignup_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: '30d_resignup' })
}

export const click_tracking_dataLayer = (event: string) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: event })
}
